import { useClerk } from '@clerk/clerk-react';
import './style/UserNotFound.css';

const UserNotFound = ({ userEmail }) => {
  const { signOut } = useClerk();

  const handleSignOut = async () => {
    await signOut();
    window.location.href = '/';
  };

  return (
    <div className="user-not-found-container">
      <div className="user-not-found-background">
        <div className="gradient-bg">
          <div className="gradient-1"></div>
          <div className="gradient-2"></div>
        </div>
      </div>

      <div className="user-not-found-content">
        <div className="user-not-found-card">
          {/* Icône d'erreur */}
          <div className="error-icon-container">
            <svg 
              className="error-icon" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 8V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <circle cx="12" cy="16" r="1" fill="currentColor"/>
            </svg>
          </div>

          {/* Titre principal */}
          <h1 className="error-title">Accès non autorisé</h1>

          {/* Message principal */}
          <div className="error-message">
            <p className="error-text-main">
              Votre adresse e-mail <strong>{userEmail}</strong> n'est pas enregistrée dans notre système TradeVault.
            </p>
            
            <div className="error-divider"></div>

            <p className="error-text-secondary">
              Vous ne pouvez pas accéder à la plateforme pour le moment.
            </p>
          </div>

          {/* Colonne gauche - Instructions */}
          <div className="left-column">
            <div className="instructions-box">
              <h3 className="instructions-title">Que faire ?</h3>
              <ul className="instructions-list">
                <li>
                  <svg className="check-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                  </svg>
                  <span>Contactez votre <strong>manager</strong> ou <strong>responsable</strong></span>
                </li>
                <li>
                  <svg className="check-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                  </svg>
                  <span>Demandez l'activation de votre compte TradeVault</span>
                </li>
                <li>
                  <svg className="check-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                  </svg>
                  <span>Vérifiez votre adresse e-mail professionnelle</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Colonne droite - Support */}
          <div className="right-column">
            <div className="support-box">
              <p className="support-text">
                <svg className="support-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/>
                  <circle cx="12" cy="11" r="1"/>
                  <circle cx="9" cy="11" r="1"/>
                  <circle cx="15" cy="11" r="1"/>
                </svg>
                Besoin d'aide ? Contactez l'administrateur
              </p>
              <a href="mailto:contact@makeit-solutions.com" className="support-email">
                contact@makeit-solutions.com
              </a>
            </div>
          </div>

          {/* Bouton retour et footer */}
          <div className="bottom-section">
            <button onClick={handleSignOut} className="back-button">
              <svg className="back-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
              </svg>
              Retour à la page de connexion
            </button>

            <p className="info-footer">
              Une fois votre compte activé, vous pourrez vous connecter avec cette adresse e-mail.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserNotFound;